// extracted by mini-css-extract-plugin
module.exports = {"container":"InsuranceType_container__36fxe","form":"InsuranceType_form__1mLI1"};